import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';
import ScrollLock from 'react-scrolllock';
import screen from 'superior-mq';
import { bp } from 'Styles/helpers';
import Logo from '../../logo';
import GullSelect from '../../forms/gull-select';
import Button from '../../button';
import Waves from '../../waves';

const options = [
  { value: 'US', label: 'United States' },
  { value: 'AU', label: 'Australia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'PH', label: 'Philippines' },
];

const getInitialCountry = userRegion => options.filter(option => option.value === userRegion)[0];

export default class CountryModal extends React.Component {

  static propTypes = {
    regionSubmit: PropTypes.func,
    userRegion: PropTypes.string,
  }

  state = {
    region: getInitialCountry(this.props.userRegion),
  }

  // first param is used in formik implementation
  // so it's not used here but needed to make the
  // function work without Formik
  handleChange = (zilch, region) => {
    this.setState({ region });
  }

  getUrl = (region) => {
    let url;

    switch (region) {
      case 'AU':
      case 'NZ':
        url = '/australia';
        break;
      case 'PH':
        url = '/philippines';
        break;
      default:
        url = '/';
        break;
    }

    return url;
  }

  render() {
    const buttonLink = this.state.region ? this.getUrl(this.state.region.value) : '/';

    return (
      <ModalWrap
        isOpen={this.props.isOpen}
      >
        <ModalContent>
          <LogoWrapper>
            <Logo />
          </LogoWrapper>
          <ModalTitle>Select Region</ModalTitle>

          <SelectWrap>
            <GullSelect
              options={options}
              onChange={this.handleChange}
              value={this.state.region}
              isSearchable={false}
              isDark
            />
          </SelectWrap>

          <Button
            isdark
            onClick={(e) => { this.props.regionSubmit(e, buttonLink); }}
          >
            Submit
          </Button>
        </ModalContent>

        <Waves
          position="bottom"
          alignment="bottom"
          height={320}
          color="#fff"
        />

        <ScrollLock isActive={this.props.isOpen} />

      </ModalWrap>
    );
  }
}

const ModalWrap = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding-bottom: 90px;
  background-color: ${props => props.theme.black};
  color: #fff;
  text-align: center;
  z-index: 9999;
`;

const LogoWrapper = styled.div`
  position: absolute;
  top: 84px;
  left: 74px;
  color: #fff;
  width: 152px;
  height: 53px;

  ${screen.below(bp.desktop, `
    top: 60px;
    left: 60px;
  `)}

  ${screen.below(bp.laptop, `
    top: 40px;
    left: 40px;
  `)}

  ${screen.below(bp.portrait, `
    width: 78px;
    height: 28px;
    left: 20px;
    top: 20px;
  `)}
`;

const ModalTitle = styled.h2`
  font-size: ${rem(36)};
`;

const SelectWrap = styled.div`
  margin: 60px 0;

  ${screen.below(bp.laptopSm, `
    margin: 40px 0;
  `)}
`;

const ModalContent = styled.div`
  width: 100%;
  max-width: 720px;
  margin: auto;
  padding: 0 20px;
`;
